import React, { FC } from 'react';
import { Panel } from '@component/Panel';
import {
    OrderPartsHelpContents,
    Title,
    Paragraph,
    SubTitle,
} from './OrderPartsHelpContents';
import { SakuraIcon } from './SakuraIcon';
import { OrderPartsHelpProps } from './type';
import { handleKeyPress } from './handleKeyPress';

interface Props {
    className?: string;
}

export const UnitInner: FC<Props> = ({ className }) => (
    <OrderPartsHelpContents className={className}>
        <Title>
            <SakuraIcon />
            矢の本数の決め方
        </Title>
        <SubTitle>矢の本数について</SubTitle>
        <Paragraph>
            矢の本数は、1回のご注文で6本を注文される方が多いです。
            また、練習量が多い方などは8本ご購入されることもあります。
        </Paragraph>

        <Paragraph>
            ※基本的には偶数本単位で、甲矢と乙矢が同じ本数になるようおつくりいたします。
        </Paragraph>
    </OrderPartsHelpContents>
);

export const OrderPartsHelpUnit: FC<OrderPartsHelpProps> = ({
    isOpen,
    handleClose,
}) => (
    <Panel isOpen={isOpen} onRequestClose={handleClose}>
        <div
            className="order-parts-help-panel-close"
            onClick={handleClose}
            onKeyPress={handleKeyPress(handleClose)}
            role="button"
            tabIndex="0"
        >
            <i className="icon-close" />
        </div>
        <div className="order-parts-help-panel">
            <div className="scrollable">
                <UnitInner />
            </div>
        </div>
    </Panel>
);
